import { render, staticRenderFns } from "./ModeOofTransportation.vue?vue&type=template&id=515a30a4&scoped=true&"
import script from "./ModeOofTransportation.vue?vue&type=script&lang=js&"
export * from "./ModeOofTransportation.vue?vue&type=script&lang=js&"
import style0 from "./ModeOofTransportation.vue?vue&type=style&index=0&id=515a30a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515a30a4",
  null
  
)

export default component.exports